var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookinline = function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Socials"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Facebook",
    d: "M11.645 17.905v-7.208h2.541l.38-2.81h-2.921V6.095c0-.813.237-1.367 1.462-1.367l1.562-.001V2.213a21.95 21.95 0 0 0-2.276-.11c-2.253 0-3.795 1.309-3.795 3.713v2.072H6.05v2.809h2.548v7.208h3.047Z",
    fill: "#fff"
  }))));
};
export default SvgFacebookinline;